<template>
  <b-modal
    ref="documentosPropModal"
    size="lg"
    hide-footer
    no-close-on-backdrop
    scrollable
    :dialog-class="'alteracao-tamanho-pre-geracao'"
    :modal-class="'center-modal'"
    title="Documentos da Proposta"
    title-class="titulo-modal"
    @show="show"
    @hide="close"
  >
    <div>
      <div class="mb-2 border p-1">
        <p>
          <strong>Atenção:</strong> Os documentos abaixo são essenciais para a proposta. Caso não possua todos em mãos neste momento, você poderá realizar o envio posteriormente.
        </p>
      </div>
      <documentos-proposta-section :proposta-id="propostaId" />
    </div>
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue'

export default {
  name: 'DocumentosPropostaModal',
  components: {
    BModal,
    DocumentosPropostaSection: () => import('./DocumentosPropostaSection.vue'),
  },
  props: {
    propostaId: {
      type: [Number, null],
      default: null,
      required: false,
    },
  },
  mounted() {
  },
  methods: {
    show() {
      this.$refs.documentosPropModal.show()
    },
    close() {
      this.$refs.documentosPropModal.hide()
    },
  },
}
</script>
